import { useEffect, useState } from 'react';

/** The current time, refreshed every `intervalMs`, for relative times like "3 min ago". */
export function useNow(intervalMs: number): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return now;
}
